module.exports = __webpack_public_path__ + "media/Carate.44c11a53.mp3";